export const useTypeDetection = () => {
  const detectType = (rawValue: string) => {
    const value = rawValue.trim();

    if (!value) {
      return {
        type: "empty",
        label: "No value",
        explanation: "Koi value enter karo taake type detect ho.",
      };
    }

    if (/^(true|false)$/i.test(value)) {
      return {
        type: "bool",
        label: "bool",
        explanation: "True ya False boolean hota hai.",
      };
    }

    if (/^-?\d+$/.test(value)) {
      return {
        type: "int",
        label: "int",
        explanation: "Decimal ke baghair number integer hota hai.",
      };
    }

    if (/^-?\d+\.\d+$/.test(value)) {
      return {
        type: "float",
        label: "float",
        explanation: "Decimal wala number float hota hai.",
      };
    }

    return {
      type: "str",
      label: "str",
      explanation: "Text string hota hai.",
    };
  };

  const convertValue = (rawValue: string, target: "int" | "float" | "str") => {
    const value = rawValue.trim();

    try {
      if (target === "str") {
        return {
          ok: true,
          result: String(value),
          message: "str() value ko text bana deta hai.",
        };
      }

      if (target === "int") {
        if (!/^-?\d+(\.\d+)?$/.test(value)) {
          throw new Error("Sirf numeric value int() mein convert hoti hai.");
        }

        return {
          ok: true,
          result: String(parseInt(value, 10)),
          message: "int() decimal ka integer part rakhta hai.",
        };
      }

      if (!/^-?\d+(\.\d+)?$/.test(value)) {
        throw new Error("Sirf numeric value float() mein convert hoti hai.");
      }

      return {
        ok: true,
        result: String(parseFloat(value)),
        message: "float() value ko decimal form mein dikhata hai.",
      };
    } catch (error) {
      return {
        ok: false,
        result: "",
        message: error instanceof Error ? error.message : "Conversion failed.",
      };
    }
  };

  return {
    convertValue,
    detectType,
  };
};
